module.exports = __webpack_public_path__ + "static/media/right-button-on.aed8c36a.png";